
export function Description({ description }: { description: string; }) {
    return (
        <div>
            <h3 className="mb-2 text-stone-900 dark:text-stone-50">Notes:</h3>
            {description &&
                <div className="bg-stone-100 dark:bg-stone-800 rounded-md p-4 border-2 border-stone-200 dark:border-stone-700">
                    <p className="text-stone-900 dark:text-stone-50">{description}</p>
                </div>}
        </div>
    );
}
